<template>
  <header class="header">
    <div class="container">
      <div class="header-content">
        <div class="logo">
          <router-link to="/home" exact-active-class="active">
            <img src="../../assets/common/header/yx_logo.png" alt="Logo">
          </router-link>
        </div>
        <nav class="nav-menu">
          <ul>
            <li class="news-dropdown">
              <router-link to="/home" active-class="dropdown-active" class="dropdown-toggle-link" :class="{'dropdown-active': $route.path.startsWith('/news')}">
                <span class="dropdown-toggle">{{ t('header.home') }}</span>
              </router-link>
              <ul class="dropdown-menu">
                <li>
                  <img src="../../assets/common/header/line_org.png" alt="" class="header-bottom-line">
                </li>
                <li>
                  <router-link to="/home#product_sec">{{ t('homePage.productCenter.title') }}</router-link>
                </li>
                <li>
                  <img src="../../assets/common/header/line_grey.png" alt="" class="line_grey">
                </li>
                <li>
                  <router-link to="/home#about_us">{{ t('homePage.about.title') }}</router-link>
                </li>
                <li>
                  <img src="../../assets/common/header/line_grey.png" alt="" class="line_grey">
                </li>
              </ul>
            </li>
            <li class="news-dropdown">
              <router-link to="/product" active-class="dropdown-active" class="dropdown-toggle-link">
                <span class="dropdown-toggle">{{ t('header.products') }}</span>
              </router-link>

              <ul class="dropdown-menu">
                <li>
                  <img src="../../assets/common/header/line_org.png" alt="" class="header-bottom-line">
                </li>
                <li>
                  <router-link :to="{ path: '/product', query: { tab: 0 } }">{{ t('footer.products.sport')
                  }}</router-link>
                </li>
                <li>
                  <img src="../../assets/common/header/line_grey.png" alt="" class="line_grey">
                </li>
                <li>
                  <router-link :to="{ path: '/product', query: { tab: 1 } }">{{ t('footer.products.module')
                  }}</router-link>
                </li>
                <li>
                  <img src="../../assets/common/header/line_grey.png" alt="" class="line_grey">
                </li>
                <li>
                  <router-link :to="{ path: '/product', query: { tab: 2 } }">{{ t('footer.products.screen')
                  }}</router-link>
                </li>
              </ul>
            </li>

            <li class="news-dropdown">
              <router-link to="/odm" active-class="dropdown-active" class="dropdown-toggle-link">
                <span class="dropdown-toggle">{{ t('header.omdService') }}</span>
              </router-link>
              <ul class="dropdown-menu">
                <li>
                  <img src="../../assets/common/header/line_org.png" alt="" class="header-bottom-line">
                </li>
                <li>
                  <router-link to="/odm#odm_intro">{{ t('footer.odmService.omd') }}</router-link>
                </li>
                <li>
                  <img src="../../assets/common/header/line_grey.png" alt="" class="line_grey">
                </li>
                <li>
                  <router-link to="/odm#odm_deliver">{{ t('footer.odmService.advantage') }}</router-link>
                </li>
                <li>
                  <img src="../../assets/common/header/line_grey.png" alt="" class="line_grey">
                </li>
                <li>
                  <router-link to="/odm#our_lab" class="menu-item">{{ t('footer.odmService.laboratory') }}</router-link>
                </li>
              </ul>
            </li>

            <li class="news-dropdown">
              <router-link to="/about" active-class="dropdown-active" class="dropdown-toggle-link">
                <span class="dropdown-toggle">{{ t('header.about') }}</span>
              </router-link>

              <ul class="dropdown-menu">
                <li>
                  <img src="../../assets/common/header/line_org.png" alt="" class="header-bottom-line">
                </li>
                <li>
                  <router-link to="/about#company_intro" class="menu-item">{{ t('footer.about.company') }}</router-link>
                </li>
                <li>
                  <img src="../../assets/common/header/line_grey.png" alt="" class="line_grey">
                </li>
                <li>
                  <router-link to="/about#company_video" class="menu-item">{{ t('footer.about.vedio') }}</router-link>
                </li>
                <li>
                  <img src="../../assets/common/header/line_grey.png" alt="" class="line_grey">
                </li>
                <li>
                  <router-link to="/about#company_culture" class="menu-item">{{ t('footer.about.culture')
                  }}</router-link>
                </li>
              </ul>
            </li>
            <li class="news-dropdown">
              <router-link to="/contact" active-class="dropdown-active" class="dropdown-toggle-link">
                <span class="dropdown-toggle">{{ t('header.contact') }}</span>
              </router-link>
              <ul class="dropdown-menu">
                <li>
                  <img src="../../assets/common/header/line_grey.png" alt="" class="line_grey">
                </li>
                <li>
                  <router-link to="/contact#contact_info" class="menu-item">{{ t('footer.contact.method')
                  }}</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        <div class="header-right">
          <LanguageSwitch />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { useI18n } from 'vue-i18n'
import LanguageSwitch from './LanguageSwitch.vue'
import { useHead } from '@vueuse/head'


export default {
  name: 'WebHeader',
  components: {
    LanguageSwitch
  },
  setup() {
    const { t } = useI18n()
    return { t }
  }
}


useHead({
  title: '深圳市研兴科技有限公司 - 智能终端研发',
  meta: [
    { name: 'description', content: '深圳市研兴科技有限公司成立于2005年，是国家高新技术企业与双软认证企业，以硬件+软件+场景适配”一体化ODM服务能力，为全球客户提供0.96-23.8英寸全尺寸智能显示终端定制化解决方案。' },
    { name: 'keywords', content: '研兴科技, 高科技企业, 解决方案, 智能终端, 深圳研发' }
  ]
})
</script>

<style scoped>
.header {
  height: 80px;
}

.container {
  margin: 0 auto;
  height: 100%;
}

.header-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

}

.logo {
  display: flex;
  align-items: center;
}

.logo img {
  height: 50px;
  width: auto;
}

.nav-menu {
  flex: 1;
  display: flex;
  justify-content: center;
}

.nav-menu ul {
  display: flex;
  list-style: none;
  gap: 3vw;
  margin: 0;
  padding: 0;
}

.nav-menu a {
  color: #222;
  font-size: 16px;
  /* 需要完成适配 */
  padding: 1vw;
  transition: color 0.2s;
  text-decoration: none;
}

.nav-menu a.active {
  color: #f98335 !important;
  font-weight: bold;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 1.5vw;
}

.header_right_img {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  border-radius: 50%;
}

.header_right_img img {
  width: 20px;
  height: 20px;
  transition: all 0.3s;
}

.header_right_img:hover {
  transform: scale(1.1);
  background: rgba(0, 0, 0, 0.1);
}

.contact-info {
  display: flex;
  align-items: center;
}

.phone {
  font-size: 16px;
  color: #666;
}

.news-dropdown {
  position: relative;
}

/* 添加伪元素填补间隙 */
.news-dropdown::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 100%;
  /* 填补到下拉菜单的距离 */
}

.dropdown-active .dropdown-toggle {
  color: #f98335;
  /* text-decoration: underline; */
}

.dropdown-toggle-link {
  text-decoration: none;
  white-space: nowrap;
  /* 禁止文本换行 */
  overflow: hidden;
  /* 隐藏溢出内容 */
  text-overflow: ellipsis;
  /* 溢出内容用省略号显示 */
}

.news-dropdown .dropdown-menu {
  display: none;
}

.news-dropdown:hover .dropdown-menu {
  display: block;
}

.dropdown-menu {
  display: none;
  position: absolute;
  top: 200%;
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  z-index: 999;
  padding: 8px 0;
  min-width: 160px;
  text-align: center;
}

.dropdown-menu li {
  font-size: 14px;
  text-align: center;
  line-height: 1.2;
}

.dropdown-menu li:last-child {
  border-bottom: none;
}

.dropdown-menu a {
  color: #191717;
  text-decoration: none;
  display: block;
}

.dropdown-menu a:hover {
  color: #f98335;
  background-color: #f9f9f9;
}

.line_grey {
  width: 80%;
  display: block;
  margin: 0 auto;
  padding: 0;
}

@keyframes line-grow-center {
  from {
    width: 0;
  }

  to {
    width: 50%;
  }
}

.header-bottom-line {
  position: absolute;
  top: auto;
  top: -4%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  width: 50%;
  animation: line-grow-center 1s ease-in-out;
  transform-origin: center;
}

/* 大屏幕设备 (1400px 以上) */
@media screen and (min-width: 1400px) {
  .container {
    max-width: 80%;
  }

  .nav-menu a {
    font-size: 16px;
  }

  .phone {
    font-size: 16px;
  }

  .logo img {
    height: 45px;
    width: auto;
  }

  .header-bottom-line {
    height: 4px;
  }

  .dropdown-menu {
    min-width: 160px;
  }

  .nav-menu ul {
    gap: 3vw;
  }

  .header_right_img img {
    width: 30px;
    height: 30px;
  }

  @keyframes line-grow-center {
  from {
    width: 0;
  }

  to {
    width: 45%;
  }
}

.header-bottom-line {
  position: absolute;
  top: auto;
  top: -4%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  width: 45%;
  animation: line-grow-center 1s ease-in-out;
  transform-origin: center;
}
}

/* 笔记本电脑 */
@media screen and (max-width: 1399px) {
  .container {
    max-width: 92%;
  }

  .nav-menu a {
    font-size: 15px;
  }

  .phone {
    font-size: 15px;
  }

  .logo img {
    height: 40px;
    width: auto;
  }

  .header-bottom-line {
    height: 3px;
  }

  .dropdown-menu {
    min-width: 140px;
  }

  .nav-menu ul {
    gap: 3vw;
  }

  .header_right_img img {
    width: 26px;
    height: 26px;
  }

  @keyframes line-grow-center {
  from {
    width: 0;
  }

  to {
    width: 40%;
  }
}

.header-bottom-line {
  position: absolute;
  top: auto;
  top: -4%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  width: 40%;
  animation: line-grow-center 1s ease-in-out;
  transform-origin: center;
}
}

/* 平板设备 */
@media screen and (max-width: 991px) {
  .container {
    max-width: 100%;

  }

  .logo img {
    height: 35px;
    width: auto;
  }

  .nav-menu a {
    font-size: 12px;
  }

  .phone {
    font-size: 12px;
  }

  .header-bottom-line {
    height: 2px;
  }

  .dropdown-menu {
    min-width: 120px;
  }

  .nav-menu ul {
    gap: 2vw;
  }

  .header_right_img img {
    width: 22px;
    height: 22px;
  }

  @keyframes line-grow-center {
  from {
    width: 0;
  }

  to {
    width: 35%;
  }
}

.header-bottom-line {
  position: absolute;
  top: auto;
  top: -4%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  width: 35%;
  animation: line-grow-center 1s ease-in-out;
  transform-origin: center;
}
}

/* 手机设备 */
@media screen and (max-width: 767px) {
  .container {
    max-width: 100%;
  }

  .logo img {
    height: 30px;
    width: auto;
  }

  .nav-menu a {
    font-size: 10px;
  }

  .phone {
    font-size: 10px;
  }

  .header-bottom-line {
    height: 2px;
  }

  .dropdown-menu {
    min-width: 100px;
  }

  .nav-menu ul {
    gap: 0.5vw;
  }

  .header_right_img img {
    width: 18px;
    height: 18px;
  }

  @keyframes line-grow-center {
  from {
    width: 0;
  }

  to {
    width: 30%;
  }
}

.header-bottom-line {
  position: absolute;
  top: auto;
  top: -4%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  width: 30%;
  animation: line-grow-center 1s ease-in-out;
  transform-origin: center;
}
}
</style>